// removed by extract-text-webpack-plugin
module.exports = {"page":"page","page_overflow":"page_overflow","popup":"popup","popup_open":"popup_open","popup_loading":"popup_loading","popup__content":"popup__content","popup__overlay":"popup__overlay","open":"open","popup__close":"popup__close","popup__wrap":"popup__wrap","popup__inner":"popup__inner"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_popup.scss
// module id = 93
// module chunks = 0